/**
 * The communities this setup currently supports (i.e. with icons or the
 * shareActionFactory.
 * Currently supports `twitter`, `facebook`, `whatsapp` and `share`.
 */
export var supportedCommunities = ['twitter', 'facebook', 'whatsapp', 'share'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/react-share-buttons/es/supportedCommunities.js
// module id = 26
// module chunks = 0